<div class="cell status">
  <div [ngClass]="productionScheduleItemInPathGroupStatus[productionScheduleItem.status] | lowercase" class="production-schedule-item-status">
    <span class="b2 font-weight-semibold">{{ getProductionScheduleItemStatusTranslationKey(productionScheduleItem.status) | bmsTranslate }}</span>
  </div>
</div>
